export class UploadSitesApiService {
    constructor(http) {
      this.endpoint = '/upload/sites/';
      this.http = http;
    }
    async upload(file) {
      const headers = { 'Content-Type': 'multipart/form-data' };
      const { data } = await this.http.instance.post(this.endpoint, file, {
        headers
      });
      return data;
    }
  }
  